export default "__VITE_ASSET__B$HNQQ13__"